import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {loginUser} from "../api-services/login";

export const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Auto-redirect to dashboard if user is already logged in
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            // Check if token is expired
            try {
                const payload = JSON.parse(atob(token.split('.')[1]));
                const isExpired = payload.exp * 1000 < Date.now();
                
                if (!isExpired) {
                    navigate('/dashboard', { replace: true });
                } else {
                    // Clear expired token
                    localStorage.removeItem('token');
                    localStorage.removeItem('userEmail');
                    localStorage.removeItem('userRole');
                }
            } catch (err) {
                // Invalid token format, clear it
                localStorage.removeItem('token');
                localStorage.removeItem('userEmail');
                localStorage.removeItem('userRole');
            }
        }
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await loginUser(email, password);

            if (response.ok) {
                const data = await response.json();
                if (data.access_token) {
                    localStorage.setItem('token', data.access_token);
                    if (data.email) localStorage.setItem('userEmail', data.email);
                    if (data.role) localStorage.setItem('userRole', data.role);
                    navigate('/dashboard');
                } else {
                    setError('Invalid response from server');
                }
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Login failed');
            }
        } catch (error) {
            setError('An error occurred during login.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '24px' }}>
            <div style={{ width: '100%', maxWidth: '500px' }}>
                <h1 style={{ fontSize: '28px', fontWeight: '600', color: 'white', textAlign: 'center', marginBottom: '48px' }}>
                    Login to your account
                </h1>
                
                {error && <div style={{ color: '#ef4444', marginBottom: '24px', padding: '12px', borderRadius: '6px', backgroundColor: '#fee' }}>{error}</div>}
                
                <form onSubmit={handleLogin}>
                    <input 
                        type="email"
                        placeholder="Email address" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{
                            width: '100%',
                            height: '48px',
                            padding: '12px 16px',
                            fontSize: '16px',
                            backgroundColor: 'white',
                            color: 'black',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            marginBottom: '24px',
                            outline: 'none'
                        }}
                    />
                    
                    <input 
                        type="password"
                        placeholder="Password" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        style={{
                            width: '100%',
                            height: '48px',
                            padding: '12px 16px',
                            fontSize: '16px',
                            backgroundColor: 'white',
                            color: 'black',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            marginBottom: '24px',
                            outline: 'none'
                        }}
                    />
                    
                    <button 
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%',
                            height: '48px',
                            fontSize: '16px',
                            fontWeight: '500',
                            backgroundColor: loading ? '#9ca3af' : '#22c55e',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            transition: 'background-color 0.2s'
                        }}
                    >
                        {loading ? 'Loading...' : 'Login'}
                    </button>
                </form>
                
                <div style={{ textAlign: 'center', marginTop: '32px' }}>
                    <span style={{ color: '#9ca3af' }}>Don&apos;t have an account? </span>
                    <Link to="/register" style={{ color: '#22c55e', textDecoration: 'none' }}>Register</Link>
                </div>
            </div>
        </div>
    )

}